import {type RouteLocationStringParam, type RouteRecordRaw} from 'vue-router';

const GalleryList      = () => import('../views/gallery/GalleryList.vue');
const GalleryEdit      = () => import('../views/gallery/GalleryEdit.vue');
const GalleryView      = () => import('../views/gallery/GalleryView.vue');
const GalleryViewImage = () => import('../views/gallery/GalleryViewImage.vue');
const GallerySettings  = () => import('../views/gallery/GallerySettings.vue');

let meta: MetaData = {module: 'gallery'};

let gallery: RouteRecordRaw[] = [
    {
        path: '/gallery',
        redirect: {name: 'gallery-list'},
        meta,
    },
    {
        path: '/gallery/list',
        name: 'gallery-list',
        component: GalleryList,
        meta,
    },
    {
        path: '/gallery/add',
        name: 'gallery-add',
        component: GalleryEdit,
        props: {id: 0},
        meta,
    },
    {
        path: '/gallery/view/id/:id/image/:image',
        name: 'gallery-view-image',
        component: GalleryViewImage,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id),
                image: parseInt(route.params.image),
            };
        },
        meta: {
            disableScrollOnParamChange: true,
            ...meta,
        },
    },
    {
        path: '/gallery/edit/id/:id/:wildcard*',
        name: 'gallery-edit',
        component: GalleryEdit,
        props(route: RouteLocationStringParam)
        {
            return {id: parseInt(route.params.id)};
        },
        meta,
    },
    {
        path: '/gallery/view/id/:id/:wildcard*',
        name: 'gallery-view',
        component: GalleryView,
        props(route: RouteLocationStringParam)
        {
            return {id: parseInt(route.params.id)};
        },
        meta,
    },
    {
        path: '/gallery/settings/:route(intranet)?',
        name: 'gallery-settings',
        component: GallerySettings,
        meta,
        children: [
            {
                path: 'view',
                name: 'gallery-settings-view',
                meta,
                component: GallerySettings,
            },
            {
                path: 'rights',
                name: 'gallery-settings-rights',
                meta,
                component: GallerySettings,
            },
            {
                path: 'download',
                name: 'gallery-settings-downloads',
                meta,
                component: GallerySettings,
            },
            {
                path: 'category',
                name: 'gallery-settings-categories',
                meta,
                component: GallerySettings,
            },
        ],
    },
    {
        path: '/gallery/settings/backlink/:backlink',
        name: 'gallery-settings-backlink',
        component: GallerySettings,
        props(route: RouteLocationStringParam)
        {
            return {backlink: route.params.backlink};
        },
        meta,
    },
    // COMPATIBILITY: OLD PATHS
    {
        path: '/gallery/index/index',
        redirect: {name: 'gallery-list'},
        meta,
    },
    {
        path: '/gallery/index/list',
        redirect: {name: 'gallery-list'},
        meta,
    },
    {
        path: '/gallery/setting/edit',
        redirect: {name: 'gallery-settings'},
        meta,
    },
    {
        path: '/gallery/index/view/id/:id/:wildcard*',
        redirect: {name: 'gallery-view'},
        meta,
    },
    {
        path: '/gallery/setting/edit/backlink/:backlink',
        redirect: {name: 'gallery-settings-backlink'},
        meta,
    },
];

export default gallery;
